import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=6668e23a&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports